export enum BaryTableDataEnum {
  ADDRESSES = 'ADDRESSES',
  TRANSPORT_ORDERS = 'TRANSPORT_ORDERS',
  CUSTOMER_BILLS = 'CUSTOMER_BILLS',
  MODERATOR_BILLS = 'MODERATOR_BILLS',
  TRANSPORTER_MEMBERS = 'TRANSPORTER_MEMBERS',
  QUOTES = 'QUOTES',
  CUSTOMERS = 'CUSTOMERS',
  CUSTOMER_PRICING = 'CUSTOMER_PRICING',
  UPLOAD_PRICING_ITEMS = 'UPLOAD_PRICING_ITEMS',
  ACCEPTANCES = 'ACCEPTANCES',
  CUTOFFS = 'CUTOFFS',
  OFFERS = 'OFFERS',
  MERCHANDISES = 'MERCHANDISES',
  OFFER_INSURANCE_ITEMS = 'OFFER_INSURANCE_ITEMS',
  OFFER_INSURANCE_ITEMS_LIGHT = 'OFFER_INSURANCE_ITEMS_LIGHT',
  TRANSPORTERS = 'TRANSPORTERS',
  USERS = 'USERS',
  MODERATORS = 'MODERATORS',
  SERVICES = 'SERVICES',
  NOTIFICATIONS = 'NOTIFICATIONS',
  IMPERSONATE = 'IMPERSONATE',
  REFUNDS = 'REFUNDS',
  SPECIAL_PLACE = 'SPECIAL_PLACE',
  TRANSPORTS_PENDING = 'TRANSPORTS_PENDING',
}
